import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import birs from "../../static/birs.png";
import auth from "../auth";
import Drawer from "../SideDrawer/DrawerToggle";
import "./NavBar.css";

class NavBar extends Component {
  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };
  render() {
    return (
      <header className="toolbar">
        <nav className="toolbar_navigation">
          <div className="toolbar_toggle-button">
            <Drawer click={this.props.drawerClickHandler} />
          </div>
          <div className="toolbar_logo">RHM</div>
          <div className="spacer" />
          <div style={styles.company}>
            <img style={styles.image} src={birs} alt="kgirs" />
          </div>
          <div className="toolbar_navigation-items">
            <ul>
              <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/profile">My Profile</Link>
              </li>
              <li>
                <Link to="/view">View Tax Payers</Link>
              </li>
              <li>
                <Link to="/new">Add Tax Payer</Link>
              </li>
              <li>
                <Link to="/calc">Tax Calculator</Link>
              </li>
              <li>
                <Link to="/settings">Settings</Link>
              </li>
              <li>
                <Link onClick={this.logout} to="/">
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }
}

const styles = {
  company: {
    display: "flex",
    justifyContent: "flex-end"
  },
  image: {
    marginRight: 20
  }
};
export default withRouter(NavBar);
